import { types } from './actions';

const initialState = {
  isOpen: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.contacts.contactDetails.drawers.accounts;

export const getIsOpen = (state) => getScope(state).isOpen;

export default reducer;
